import repoUrls from 'src/sections/repository/urls';

import { MavenBaseVersionResponse } from '../../types';
import { buildPackagesApiQueryString } from '../../utils';
import { packagesResourceFactory } from '../utils';

export const packagesMavenBaseVersionResource =
  packagesResourceFactory<MavenBaseVersionResponse>()({
    key: 'packages-maven-base-version',
    pathParamNames: ['packageName', 'mavenBaseVersion'] as const,
    queryParamNames: [] as const,
    getRequestUrl: (context, pathParams, _queryParams) => {
      const queryString = buildPackagesApiQueryString({
        packageName: pathParams.packageName,
        baseVersion: pathParams.mavenBaseVersion,
      });

      switch (context.container) {
        case 'repository':
          return repoUrls.api.internal.mavenBaseVersion(
            context.workspaceSlug,
            context.repositorySlug,
            queryString
          );
        default:
          throw new Error('Invalid route context');
      }
    },
  });
